import styles from "./navlink.module.css";
import {Link} from 'react-router-dom';

export default function Navlink({ href, bgColor, icon, text }) {
    return (
        <Link
          to={href}
          className={styles.container}
          style={{backgroundColor: bgColor}}
        >
            <img src={icon} width="24px" height="24px"/>
            <span className={styles.text}>{text}</span>
        </Link>
    )
}